import React from 'react';
import { LeadForm } from '../../components/LeadForm';
export function StartFreeHeroForm() {
  return <div className="bg-paper p-6 rounded-2xl shadow-xl max-w-md" data-id="element-3085">
      <h3 className="text-2xl text-ink mb-4 text-center" data-id="element-3086">
        Start Your Child's Free Week
      </h3>
      <LeadForm buttonText="Claim Free Week" data-id="element-3087" />
    </div>;
}